<template>
    <el-dialog class="peiso-modal loading-container"
    :visible.sync="isOpen"
    :modal-append-to-body="false"
    :close-on-click-modal='false'
    :close-on-press-escape="false"
    width="450px"
    :before-close="handleClose"
    center>

        <div class="body-container d-flex flex-column gap-10">
            <span>{{ loadingLabel }}</span>

            <div>
                <el-progress class="loading-progress pink-progress" :percentage="loadingPecentage" :stroke-width="15" :show-text="false" />
            </div>
        </div>

    </el-dialog>
</template>

<style lang='scss'>
@import '../../../static/scss/colors.scss';
@import '../../../static/scss/fonts/fonts.scss';
    .loading-container {
        .el-dialog__headerbtn {
            display: none;
        }

        .body-container {
            span {
                @include montserrat-font(14px, normal, 500, #fff) {
                    margin-bottom: 10px;
                }
            }
        }
    }
</style>

<script>
    import utils from '../../utils/utils'
    export default {
        data() {
            return {
                isOpen: false,
                isLoading: false,
            }
        },
        props: {
            open: {
                default: false
            },
            loadingLabel: '',
            loadingPecentage: 0
        },
        watch: {
            open(val) {
                this.isOpen = val
            }
        },
        computed: {

        },
        methods: {
            handleClose() {
                this.isOpen = false
                this.$emit('close-modal')
            },
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modal/loading.vue